import Cookies from 'js-cookie';
import {
  AUTH_COOKIE_NAMES,
  AUTH_LOCAL_STORAGE_KEYS,
  PRESERVE_LOCAL_STORAGE_KEYS,
} from './authStorageKeys';

// Cookie configuration
const COOKIE_CONFIG = {
  expires: 7, // 7 days
  secure: process.env.NODE_ENV === 'production',
  sameSite: 'strict',
};

// Token management functions
export const setTokenCookie = (token) => {
  if (token) {
    Cookies.set('token', token, COOKIE_CONFIG);
  }
};

export const getTokenCookie = () => {
  return Cookies.get('token');
};

export const removeTokenCookie = () => {
  Cookies.remove('token');
};

// Other user data cookie functions
export const setUserCookie = (key, value) => {
  if (value !== undefined && value !== null) {
    Cookies.set(key, value, COOKIE_CONFIG);
  }
};

export const getUserCookie = (key) => {
  return Cookies.get(key);
};

export const removeUserCookie = (key) => {
  Cookies.remove(key);
};

// Helper function to get token from cookies only
export const getToken = () => {
  return getTokenCookie();
};

// Helper function to set token in cookies only
export const setToken = (token) => {
  setTokenCookie(token);
};

// Token validation functions
export const isTokenExpired = (token) => {
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    return payload.exp < currentTime - 300;
  } catch (error) {
    return true;
  }
};

export const isUserAuthenticated = () => {
  const token = getToken();
  return token && !isTokenExpired(token);
};

const clearAuthCookies = () => {
  AUTH_COOKIE_NAMES.forEach((name) => {
    Cookies.remove(name);
    Cookies.remove(name, { path: '/' });
  });

  document.cookie.split(';').forEach((cookie) => {
    const [name] = cookie.trim().split('=');
    if (
      name &&
      (name.includes('user') || name.includes('auth') || name.includes('token'))
    ) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  });
};

const clearAuthLocalStorage = () => {
  const preserve = new Set(PRESERVE_LOCAL_STORAGE_KEYS);

  AUTH_LOCAL_STORAGE_KEYS.forEach((key) => {
    if (!preserve.has(key)) {
      localStorage.removeItem(key);
    }
  });

  // Remove dynamic keys (e.g. booking status colors) and any auth data not in the list
  Object.keys(localStorage).forEach((key) => {
    if (!preserve.has(key)) {
      localStorage.removeItem(key);
    }
  });
};

/** Clear all authentication data (cookies, localStorage session, sessionStorage). */
export const clearAuthData = () => {
  clearAuthCookies();
  clearAuthLocalStorage();

  try {
    sessionStorage.clear();
  } catch (error) {
    // ignore
  }

  window.dispatchEvent(new CustomEvent('userLoggedOut'));

  // After sweep so other tabs can detect logout via storage event
  try {
    localStorage.setItem('logout', String(Date.now()));
  } catch (error) {
    // ignore
  }
};
